import { useShiftNote } from 'shared/hooks/api/shiftNotes';

export default function useNoteEvent(noteId: string | null): string | null {
  const { data: note } = useShiftNote(noteId || undefined);
  return note?.event ?? null;
}
